import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../nonregister/Navbar';
import Footer from '../../nonregister/Footer';
import AIPublicAssistant from '../ai/AIPublicAssistant';

/**
 * PublicLayout component for non-authenticated users
 * Wraps public pages with Navbar, Footer, and AI Public Assistant
 */
const PublicLayout = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <main style={{ flex: 1 }}>
                <Outlet />
            </main>
            <Footer />
            <AIPublicAssistant />
        </div>
    );
};

export default PublicLayout;
